module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background-01"
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('ui-simple-lsc', {
    attrs: {
      "vidTittle": 'Fin del curso',
      "videoEmbed": "ADMINISTRACIONDINERO57FinDelCurso.mp4"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('ui-title-red', {
    attrs: {
      "textTitle": "Fin del curso"
    }
  }), _vm._v(" "), _c('v-flex', {
    staticClass: "animated fadeInLeft",
    attrs: {
      "xs12": "",
      "md5": "",
      "text-xs-center": ""
    }
  }, [_c('image-app', {
    attrs: {
      "imaSize": 250,
      "imaSrc": "contenido/diapositiva_27",
      "imaAlt": "Mujer sonriendo recostada en el cuadro de texto"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "aligner animated fadeInUp",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('div', [_c('ui-finalcurso', {
    staticClass: "animated rotateIn"
  }), _vm._v(" "), _c('div', {
    staticClass: "margin-auto"
  }, [_c('div', [_c('audio-player', {
    ref: "audioPlayer",
    attrs: {
      "audios": [
        'Administracion7.mp3'
      ]
    }
  })], 1)])], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c9b783d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/screens/00-davivienda/davivienda-57.vue
// module id = 1029
// module chunks = 1